import { render, staticRenderFns } from "./FieldSetFieldAdmin.vue?vue&type=template&id=ef33ba12&scoped=true"
import script from "./FieldSetFieldAdmin.vue?vue&type=script&lang=js"
export * from "./FieldSetFieldAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef33ba12",
  null
  
)

export default component.exports